import { useEffect, useState } from 'react';
import { _single } from '../../../core/services/dataBean/EntityCatalog';
import { toast } from 'react-toastify';

interface Props {
    label?: string;
    name: string;
    value: any;
    setDate?: (date: any) => void;
    _disable?: boolean;
    notDate?: boolean;
    onChangeE?: (date: any) => void;
    currentTerm?: boolean;
    withTime?: boolean;
}

export const InputDate = ({ label = '', name, value, setDate = () => { }, _disable = false, notDate = false, onChangeE, currentTerm = false, withTime = false }: Props) => {
    const [miFecha, setMifecha] = useState<string>('');

    const toInputValue = (d: Date) => {
        const pad = (n: number) => String(n).padStart(2, '0');
        const yyyy = d.getFullYear();
        const mm = pad(d.getMonth() + 1);
        const dd = pad(d.getDate());
        const hh = pad(d.getHours());
        const mi = pad(d.getMinutes());
        const ss = pad(d.getSeconds());

        return withTime ? `${yyyy}-${mm}-${dd}T${hh}:${mi}:${ss}` : `${yyyy}-${mm}-${dd}`;
    };

    const toOutputValue = (input: string) => {
        if (!withTime) {
            const now = new Date();
            const pad = (n: number) => String(n).padStart(2, '0');
            const currentTime = `${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;
            return `${input} ${currentTime}`;
        }

        const [datePart, timePartRaw] = input.split('T');
        const timePart = (timePartRaw ?? '00:00').length === 5 ? `${timePartRaw}:00` : (timePartRaw ?? '00:00:00');
        return `${datePart} ${timePart}`;
    };

    useEffect(() => {
        if (value === undefined || value === null || value === '') {
            setMifecha('');
            return;
        }

        try {
            const d = new Date(value);
            if (isNaN(d.getTime())) {
                setMifecha('');
                return;
            }
            setMifecha(toInputValue(d));
        } catch {
            setMifecha('');
        }
    }, [value, withTime]);

    const update = (inputValue: string) => {
        if (!inputValue) {
            setDate(null);
            setMifecha('');
            onChangeE?.(null);
            return;
        }

        const dateYear = parseInt(inputValue.substring(0, 4), 10);

        if (currentTerm && _single.getCurrenYear() !== dateYear) {
            toast.error('Solo vigencia Actual');
            return;
        }

        const out = toOutputValue(inputValue);
        setDate(out);
        setMifecha(inputValue);
        onChangeE?.(out);
    };

    return (
        <>
            {label && <label>{label}</label>}
            <input
                disabled={_disable}
                type={withTime ? 'datetime-local' : 'date'}
                className="form-control"
                name={name}
                value={miFecha}
                onChange={e => update(e.target.value)}
                step={withTime ? 60 : undefined}
            />
        </>
    );
};